import React from 'react'
import { Link } from 'react-router-dom'
import { getTerritoryStatusColor } from '../../../components/TerritoryGrid/territoryUtils'
import { parseBBCode } from '../../../libraries/BBCode'
import TerritoryHeroArchivesNav from './TerritoryHeroArchivesNav'
import './TerritoryHero.css'

const TYPE_LABELS = {
  Shogunato: 'Imperio',
  Han: 'Han',
  Distrito: 'Distrito',
}

const STATUS_SYMBOLS = {
  Guerra: '⚔',
  Paz: '☮',
  Tensión: '⚡',
  'Conflicto Interno': '⚡',
  Alianza: '◎',
  Neutral: '◈',
}

export default function TerritoryHero({
  territory,
  adventureCount = 0,
  onCreateAdventure,
  canCreate,
  canTravel = false,
  onTravel,
}) {
  if (!territory) return null

  const typeLabel = TYPE_LABELS[territory.territory_type] || 'Territorio'
  const statusColor = getTerritoryStatusColor(territory.territory_status)
  const statusSymbol = STATUS_SYMBOLS[territory.territory_status] || '◈'
  const isHan = territory.territory_type === 'Han'
  const tagline = territory.shortDescription ?? territory.description ?? ''
  const taglineHtml = tagline ? parseBBCode(tagline) : ''

  return (
    <header className="territory-hero">
      <div
        className="territory-hero__bg"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/map.jpg)` }}
        aria-hidden="true"
      />
      <div className="territory-hero__overlay" aria-hidden="true" />

      <div className="territory-hero__content">
        <div className="territory-hero__main">
          <div className="territory-hero__emblem">
            <img src="/assets/images/shuriken.png" alt="" />
          </div>

          <div className="territory-hero__info">
            <span className="territory-hero__eyebrow">{typeLabel}</span>
            <h1 className="territory-hero__title">{territory.name}</h1>

            <div className="territory-hero__chips">
              {territory.territory_status && (
                <span
                  className="territory-hero__chip territory-hero__chip--status"
                  style={{ color: statusColor, borderColor: `${statusColor}55` }}
                >
                  <span aria-hidden="true">{statusSymbol}</span>
                  {territory.territory_status}
                </span>
              )}
              {territory.climate && (
                <span className="territory-hero__chip">{territory.climate}</span>
              )}
              {adventureCount > 0 && (
                <span className="territory-hero__chip">
                  <span aria-hidden="true">⚔</span> {adventureCount} aventuras
                </span>
              )}
            </div>

            {(territory.emperor_name || territory.leader_name) && (
              <div className="territory-hero__rulers">
                {territory.emperor_name && (
                  <span className="territory-hero__ruler">
                    <span className="territory-hero__ruler-title">Emperador</span>
                    {territory.emperor_name}
                  </span>
                )}
                {territory.leader_name && (
                  <span className="territory-hero__ruler">
                    <span className="territory-hero__ruler-title">{territory.leader_title || 'Kage'}</span>
                    {territory.leader_name}
                  </span>
                )}
              </div>
            )}

            {taglineHtml ? (
              <blockquote
                className="territory-hero__description territory-hero__description--tagline"
                dangerouslySetInnerHTML={{ __html: taglineHtml }}
              />
            ) : null}

            {isHan && territory.hasArchives ? (
              <TerritoryHeroArchivesNav slug={territory.slug} />
            ) : null}
          </div>
        </div>

        {(canCreate || canTravel) && (
          <div className="territory-hero__actions">
            {canTravel && (
              <button type="button" className="territory-hero__cta territory-hero__cta--travel" onClick={onTravel}>
                <span aria-hidden="true">➤</span>
                <span>Viajar</span>
              </button>
            )}
            {canCreate && (
              <button type="button" className="territory-hero__cta" onClick={onCreateAdventure}>
                <span aria-hidden="true">✦</span>
                <span>Nueva aventura</span>
              </button>
            )}
            <Link to="/hans" className="territory-hero__back">
              ← Todos los territorios
            </Link>
          </div>
        )}

        {!canCreate && !canTravel && (
          <div className="territory-hero__actions">
            <Link to="/hans" className="territory-hero__back territory-hero__back--solo">
              ← Todos los territorios
            </Link>
          </div>
        )}
      </div>

      <div className="territory-hero__bottom-line" aria-hidden="true" />
    </header>
  )
}
